module.exports = __webpack_public_path__ + "static/media/cia_da_codorna.92e950cd.png";